import Mock from 'mockjs';

//生成服从正态分布的随机数
function getNumberInNormalDistribution(miu, sigma) {
  return miu + uniform2NormalDistribution() * sigma;
}

function uniform2NormalDistribution() {
  var sum = 0.0;
  for (var i = 0; i < 12; i++) {
    sum = sum + Math.random();
  }
  return sum - 6.0;
}

/*
example response.data:
{
  "spacing": 10,
  "data": [
    {
      "name": "全程计时",
      "miu": 1.0,
      "sigma": 5.0,
      "unit": "s",
      "min": 0.0,
      "max": 100.0,
      "record": [
        {
          "shot_count": 1,
          "actual_value": [1.5, 11.5]
        },
        {
          "shot_count": 2,
          "actual_value": [2.5, 12.5]
        }
      ],
      "statistics": [
        {
          "min": 0.0,
          "max": 10.0,
          "actual_count": 0
        },
        {
          "min": 10.0,
          "max": 20.0,
          "actual_count": 2
        }
      ]
    }
  ]
}
*/

const getMockData = function ({ name, min, max, spacing, miu, sigma, unit }) {
  let record = [];
  const shot_counts = 100;
  let allRandomData = [];
  for (let i = 0; i < 100; i++) {
    const value = parseFloat(getNumberInNormalDistribution(miu, sigma).toFixed(1));
    allRandomData.push(value);
  }
  for (let i = 0; i < shot_counts; i++) {
    record.push({
      shot_count: i,
      actual_value: allRandomData.slice(i, i + 1),
    });
  }
  allRandomData.sort(function (a, b) {
    return a - b;
  });

  let statistics = [];
  let index = 0;
  for (let i = 0; i < (max - min) / spacing; i++) {
    let count = 0;
    let statisticMin = min + i * spacing;
    let statisticMax = min + (i + 1) * spacing;
    for (let j = index; j < allRandomData.length; j++) {
      if (allRandomData[j] >= statisticMin && allRandomData[j] < statisticMax) {
        count++;
      } else {
        index = j;
        break;
      }
    }
    statistics.push({
      min: statisticMin,
      max: statisticMax,
      actual_count: count,
    });
  }

  return {
    name,
    min,
    max,
    miu,
    sigma,
    unit,
    record,
    statistics,
  };
};

const mockData = getMockData({
  name: '全程计时',
  spacing: 0.5,
  min: 10,
  max: 17,
  miu: 13.6,
  sigma: 1,
  unit: 's',
});

console.log(mockData);

export default Mock.mock(/\/worklines\/.+.\/history\/quality-monitor/, {
  rst: 200,
  data: {
    spacing: 0.5,
    data: [mockData],
  },
  msg: 'success',
});
